import React from "react";
import "./Portfolio.css";
import IMG1 from "../../assets/portfolio1.jpg";
import IMG2 from "../../assets/portfolio2.jpg";
import IMG3 from "../../assets/portfolio3.jpg";
import { ProjectList } from "../../helpers/ProjectsList";
function Portfolio() {
  return (
    <section id="portfolio">
      <h5>A Showcase of My Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {ProjectList.map((project) => (
          <article className="portfolio__item" key={project.name}>
            <div className="portfolio__item-image">
              <img src={project.image} alt="" />
            </div>
            <h3>{project.name}</h3>
            <div className="portfolio__item-cta">
              <a href={project.github} className="btn" target="_blank">
                Github
              </a>
              <a href={project?.demo} target="_blank" className="btn">
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Portfolio;
